"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[597],{

/***/ 1109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);



const baseStyles = {
    solid: "group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
    outline: "group inline-flex ring-1 items-center justify-center rounded-full py-2 px-4 text-sm focus:outline-none"
};
const variantStyles = {
    solid: {
        slate: "bg-slate-900 text-white hover:bg-slate-700 hover:text-slate-100 active:bg-slate-800 active:text-slate-300 focus-visible:outline-slate-900",
        blue: "bg-blue-600 text-white hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600",
        white: "bg-white text-slate-900 hover:bg-blue-50 active:bg-blue-200 active:text-slate-600 focus-visible:outline-white"
    },
    outline: {
        slate: "ring-slate-200 text-slate-700 hover:text-slate-900 hover:ring-slate-300 active:bg-slate-100 active:text-slate-600 focus-visible:outline-blue-600 focus-visible:ring-slate-300",
        white: "ring-slate-700 text-white hover:ring-slate-500 active:ring-slate-700 active:text-slate-400 focus-visible:outline-white"
    }
};
function Button(param) {
    let { variant ="solid" , color ="slate" , className , href , contact =false , contactMobile =false , ...props } = param;
    className = (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseStyles[variant], variantStyles[variant][color], className);
    if (contact) {
        href = "/contact";
        props.children = "Neem contact op";
        if (contactMobile) {
            props.children = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "capitalize lg:normal-case",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "hidden xl:inline",
                        children: "Neem"
                    }),
                    " contact ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "hidden xl:inline",
                        children: "op"
                    })
                ]
            });
        }
    }
    return href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        className: className,
        ...props
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: className,
        ...props
    });
}


/***/ }),

/***/ 7527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6010);


function Container(param) {
    let { className , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", className),
        ...props
    });
}


/***/ }),

/***/ 3862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7527);
/* harmony import */ var _components_Logo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3848);
/* harmony import */ var _components_NavLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7472);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7536);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(196);








const links = [
    {
        label: "Vrijblijvende demo",
        link: "/demo"
    },
    {
        label: "Functies",
        link: "/#functies"
    },
    {
        label: "Over ons",
        link: "/over-ons"
    },
    {
        label: "Tarieven",
        link: "/#tarieven"
    },
    {
        label: "Voordelen",
        link: "/#waarom-bijlesplein"
    },
    {
        label: "Contact",
        link: "/contact"
    }
];
function Footer() {
    const [success, setSuccess] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null);
    const { register , handleSubmit , formState: { errors  }  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .useForm */ .cI)();
    const onSubmit = (data)=>{
        axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].post */ .ZP.post("/api/subscribe", {
            email: data.email
        }).then(function(response) {
            setError(null);
            setSuccess(true);
        }).catch(function(error) {
            var ref, ref1;
            if (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
                setError(error.response.data.message);
            } else {
                setError("Er ging iets mis bij het versturen van het formulier. Probeer het later opnieuw.");
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        className: "bg-slate-50",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "pt-16 pb-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Logo__WEBPACK_IMPORTED_MODULE_3__/* .Logo */ .T, {
                            className: "mx-auto h-10 w-auto"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                            className: "mt-10 text-sm",
                            "aria-label": "quick links",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "-my-1 flex justify-center gap-x-6 flex-wrap",
                                children: links.map((link, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NavLink__WEBPACK_IMPORTED_MODULE_4__/* .NavLink */ .O, {
                                        href: link.link,
                                        children: link.label
                                    }, index))
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.linkedin.com/company/bijlesplein/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                className: "mx-auto h-10 w-10 mt-8 text-slate-500 hover:text-slate-800",
                                width: "40",
                                height: "40",
                                viewBox: "0 0 40 40",
                                fill: "currentColor",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M35 7.20588V32.7941C35 33.3792 34.7676 33.9402 34.3539 34.3539C33.9402 34.7676 33.3792 35 32.7941 35H7.20588C6.62085 35 6.05977 34.7676 5.64609 34.3539C5.2324 33.9402 5 33.3792 5 32.7941V7.20588C5 6.62085 5.2324 6.05977 5.64609 5.64609C6.05977 5.2324 6.62085 5 7.20588 5H32.7941C33.3792 5 33.9402 5.2324 34.3539 5.64609C34.7676 6.05977 35 6.62085 35 7.20588V7.20588ZM13.8235 16.4706H9.41176V30.5882H13.8235V16.4706ZM14.2206 11.6176C14.2229 11.2839 14.1595 10.953 14.0339 10.6438C13.9084 10.3346 13.7231 10.0532 13.4888 9.81558C13.2545 9.57797 12.9756 9.38884 12.6682 9.259C12.3608 9.12915 12.0308 9.06113 11.6971 9.05882H11.6176C10.939 9.05882 10.2882 9.32841 9.80829 9.80829C9.32841 10.2882 9.05882 10.939 9.05882 11.6176C9.05882 12.2963 9.32841 12.9471 9.80829 13.427C10.2882 13.9069 10.939 14.1765 11.6176 14.1765V14.1765C11.9514 14.1847 12.2835 14.1271 12.5949 14.0069C12.9064 13.8867 13.1911 13.7063 13.4328 13.4761C13.6746 13.2458 13.8685 12.9702 14.0037 12.6649C14.1389 12.3597 14.2126 12.0308 14.2206 11.6971V11.6176ZM30.5882 22.0118C30.5882 17.7676 27.8882 16.1176 25.2059 16.1176C24.3276 16.0737 23.4532 16.2607 22.6698 16.6602C21.8864 17.0596 21.2214 17.6575 20.7412 18.3941H20.6176V16.4706H16.4706V30.5882H20.8824V23.0794C20.8186 22.3104 21.0608 21.5472 21.5565 20.9558C22.0521 20.3643 22.7611 19.9923 23.5294 19.9206H23.6971C25.1 19.9206 26.1412 20.8029 26.1412 23.0265V30.5882H30.5529L30.5882 22.0118Z"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "border-t border-slate-400/10 py-8 lg:flex lg:items-center lg:justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-sm font-semibold leading-6 text-gray-900",
                                    children: "Meld je aan voor onze nieuwsbrief"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mt-2 text-sm leading-6 text-gray-600",
                                    children: "Het laatste nieuws, artikelen en nieuwe functies direct in je inbox."
                                })
                            ]
                        }),
                        success ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "rounded-md bg-green-50 p-4 mt-4 max-w-md",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: "1.5",
                                            stroke: "currentColor",
                                            className: "h-5 w-5 text-green-400",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "ml-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-sm font-medium text-green-800",
                                            children: "Aangemeld"
                                        })
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            onSubmit: handleSubmit(onSubmit),
                            className: "mt-6 sm:flex sm:max-w-md lg:mt-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    htmlFor: "email-address",
                                    className: "sr-only",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "email",
                                    name: "email-address",
                                    id: "email-address",
                                    autoComplete: "email",
                                    required: true,
                                    className: "w-full min-w-0 appearance-none rounded-md border-0 bg-white px-3 py-1.5 text-base text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:w-56 sm:text-sm sm:leading-6",
                                    placeholder: "Vul je email in",
                                    ...register("email", {
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-4 sm:ml-4 sm:mt-0 sm:flex-shrink-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "submit",
                                        className: "flex w-full items-center justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600",
                                        children: "Aanmelden"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col items-center border-t border-slate-400/10 py-10 sm:flex-row-reverse sm:justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex gap-x-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm text-slate-500",
                                    children: "KVK: 87979284"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm text-slate-500",
                                    children: "BTW: NL864465695B01"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "mt-6 text-sm text-slate-500 sm:mt-0",
                            children: [
                                "Copyright \xa9 ",
                                new Date().getFullYear(),
                                " Bijlesplein. Alle rechten voorbehouden.",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "/algemene-voorwaarden",
                                    className: "underline",
                                    children: "Algemene voorwaarden"
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "/privacy",
                                    className: "underline",
                                    children: "Privacy"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: " text-sm text-slate-500 text-center pb-10",
                    children: "Ontwikkeld en gehost op eigen bodem \uD83C\uDDF3\uD83C\uDDF1"
                })
            ]
        })
    });
}


/***/ }),

/***/ 7027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(396);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7913);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6010);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1109);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7527);
/* harmony import */ var _components_Logo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3848);
/* harmony import */ var _components_NavLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7472);









const links = [
    {
        label: "Voordelen",
        link: "/#waarom-bijlesplein"
    },
    {
        label: "Hoe werkt het?",
        link: "/#functies"
    },
    {
        label: "Kansenongelijkheid",
        link: "/kansenongelijkheid"
    },
    {
        label: "In de praktijk",
        link: "/cases"
    },
    {
        label: "Over ons",
        link: "/over-ons"
    },
    {
        label: "Tarieven",
        link: "/#tarieven"
    }
];
function MobileNavLink(param) {
    let { href , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Popover.Button */ .J.Button, {
        as: (next_link__WEBPACK_IMPORTED_MODULE_2___default()),
        href: href,
        className: "block w-full p-2",
        children: children
    });
}
function MobileNavIcon(param) {
    let { open  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        "aria-hidden": "true",
        className: "h-3.5 w-3.5 overflow-visible stroke-slate-700",
        fill: "none",
        strokeWidth: 2,
        strokeLinecap: "round",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0 1H14M0 7H14M0 13H14",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("origin-center transition", open && "scale-90 opacity-0")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2 2L12 12M12 2L2 12",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("origin-center transition", !open && "scale-90 opacity-0")
            })
        ]
    });
}
function MobileNavigation() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Popover */ .J, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Popover.Button */ .J.Button, {
                className: "relative z-10 flex h-8 w-8 items-center justify-center [&:not(:focus-visible)]:focus:outline-none",
                "aria-label": "Toggle Navigation",
                children: (param)=>/*#__PURE__*/ {
                    let { open  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileNavIcon, {
                        open: open
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Transition.Root */ .u.Root, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Transition.Child */ .u.Child, {
                        as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                        enter: "duration-150 ease-out",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "duration-150 ease-in",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Popover.Overlay */ .J.Overlay, {
                            className: "fixed inset-0 bg-slate-300/50"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_9__/* .Transition.Child */ .u.Child, {
                        as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                        enter: "duration-150 ease-out",
                        enterFrom: "opacity-0 scale-95",
                        enterTo: "opacity-100 scale-100",
                        leave: "duration-100 ease-in",
                        leaveFrom: "opacity-100 scale-100",
                        leaveTo: "opacity-0 scale-95",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Popover.Panel */ .J.Panel, {
                            as: "div",
                            className: "absolute inset-x-0 top-full mt-4 flex origin-top flex-col rounded-2xl bg-white p-4 text-lg tracking-tight text-slate-900 shadow-xl ring-1 ring-slate-900/5",
                            children: links.map((link, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileNavLink, {
                                    href: link.link,
                                    children: link.label
                                }, index))
                        })
                    })
                ]
            })
        ]
    });
}
function Header() {
    const [atTop, setAtTop] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        function updatePosition() {
            setAtTop(window.pageYOffset > 10 ? false : true);
        }
        window.addEventListener("scroll", updatePosition);
        updatePosition();
        return ()=>window.removeEventListener("scroll", updatePosition);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("py-4 lg:py-6 fixed w-full z-40 bg-white transition-colors transition-shadow", !atTop && "bg-white shadow-xl"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                        className: "relative z-50 flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center lg:gap-x-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: "/",
                                        "aria-label": "Home",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Logo__WEBPACK_IMPORTED_MODULE_5__/* .Logo */ .T, {
                                            className: "h-8 sm:h-12 w-auto"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "hidden lg:flex lg:gap-x-2",
                                        children: links.map((link, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NavLink__WEBPACK_IMPORTED_MODULE_6__/* .NavLink */ .O, {
                                                href: link.link,
                                                children: link.label
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                        href: "/contact",
                                        color: "white",
                                        contact: true,
                                        contactMobile: true
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                        href: "/demo",
                                        color: "blue",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "capitalize xl:normal-case",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "hidden xl:inline",
                                                    children: "Gratis"
                                                }),
                                                " demo"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "-mr-1 lg:hidden",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileNavigation, {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-20"
            })
        ]
    });
}


/***/ }),

/***/ 3848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ Logo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/images/logos/logo.svg
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.753928eb.svg","height":142,"width":425});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Logo.jsx



function Logo(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        className: "h-10 w-auto",
        src: logo,
        alt: "Bijlesplein logo",
        priority: true,
        ...props
    });
}


/***/ }),

/***/ 7472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ NavLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


function NavLink(param) {
    let { href , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        className: "inline-block whitespace-nowrap rounded-lg py-1 px-2 text-sm text-slate-700 hover:bg-slate-100 hover:text-slate-900",
        children: children
    });
}


/***/ })

}]);